// Dependencies.
import styled from 'styled-components'

import { colors } from '../utils'

// Img.
const Div = styled.div`
  align-items: center;
  background: ${colors.washedPurple};
  display: flex;
  justify-content: center;
  height: 50px;
  width: 50px;
  border-radius: 100%;

  img {
    height: 24px;
    width: 24px;
  }
`

// Props.
interface Props {}

// Close Icon.
export const CloseIcon: React.FC<Props> = (props) => {
  // ..
  return (
    <Div className="closeIcon noSelect">
      <img src="/images/close.png" />
    </Div>
  )
}
